import type {
  CoreMessageKey,
  LinksCategoryId,
  LinksData,
} from '@jouzen/ecom-components';

import { POP_PATHNAME } from '@/app/consts/pathnames';

interface FormatLinksProps {
  basePathDestination: string;
  currentPath: string;
  pathname: string;
  shopButtonPOPLabel?: CoreMessageKey;
  statsigLinks: LinksData[] | undefined;
  subPathDestination: string;
  targetCategoryIds: LinksCategoryId[];
  targetLinkId: string;
}

const formatLinks = ({
  basePathDestination,
  currentPath,
  shopButtonPOPLabel,
  subPathDestination,
  pathname,
  statsigLinks,
  targetCategoryIds,
  targetLinkId,
}: FormatLinksProps) => {
  if (!statsigLinks) {
    return undefined;
  }
  // TODO - this only does a shallow copy and this is actually mutating the original data
  // copy the data
  const _links = [...statsigLinks];
  const localizedCurrentPath = new RegExp(`^(/..)?${currentPath}$`);
  if (localizedCurrentPath.test(pathname)) {
    const shopLinks = _links.filter(({ id }) => targetCategoryIds.includes(id));

    shopLinks.forEach((shopLink) => {
      if (shopLink.links) {
        shopLink.links.forEach((link) => {
          if (link.id === targetLinkId) {
            // reassign the href
            link.href = `${basePathDestination}/${subPathDestination}`;
          }
        });
      } else if (shopLink.link && shopLink.link.id === targetLinkId) {
        // reassign the href
        shopLink.link.href = `${basePathDestination}/${subPathDestination}`;
        // reassign the shop button label if on /product/rings
        if (localizedCurrentPath.test(POP_PATHNAME)) {
          shopLink.link.label = shopButtonPOPLabel ?? shopLink.link.label;
        }
      }
    });
  }
  return _links;
};

export default formatLinks;
